import addMonths from "date-fns/addMonths";
import format from "date-fns/format";
import startOfMonth from "date-fns/startOfMonth";
import endOfMonth from "date-fns/endOfMonth";
import dateToUTC from "utils/dateToUTC";

import { MonthPickerOption } from "./types";

export const getMonthSelectOptions = (
  count: number,
  startDate = new Date()
): MonthPickerOption[] =>
  Array.from({ length: count }, (_, index) => {
    const date = addMonths(startDate, index);
    const start = dateToUTC(startOfMonth(date));

    return {
      start,
      end: dateToUTC(endOfMonth(date)),
      value: start.toISOString(),
      label: format(date, "MMMM yyyy"),
    };
  });
